/**
 * A grade da linha de preferência de aviso (parte D1), numa definição só: a `LinhaDeAviso`
 * e o esqueleto de carregamento usam as MESMAS classes, e o esqueleto não deriva do
 * layout real (a cicatriz do `flex-wrap`: a 4ª pílula descia no desktop a 1 100 px).
 *
 * Fora do componente para não quebrar `react-refresh/only-export-components` (mesmo padrão
 * de `DegradedModeBadge.constants.ts`).
 */

/** A linha: texto à esquerda e pílulas à direita no desktop; empilhado no celular. */
export const GRADE_DA_LINHA =
  "grid gap-3 border-b py-4 last:border-b-0 xl:grid-cols-[minmax(220px,1fr)_auto] xl:items-center";

/** As pílulas: 2 por linha no celular; 4 colunas fixas de 150 px no desktop. */
export const GRADE_DAS_PILULAS =
  "grid max-w-[420px] grid-cols-2 gap-2 xl:max-w-none xl:grid-cols-[repeat(4,150px)]";

/** Onde ficam o rótulo e as pílulas: ao lado (a tela do interno, larga) ou o rótulo em cima e as pílulas embaixo (o portal). */
export type DisposicaoDaLinha = "lado" | "empilhada";

/**
 * Empilhada (D3, desenho do portal §5.2): a página do portal é `max-w-3xl` e o cartão tem 656 px úteis; a grade "lado" (220 + 4×150 +
 * gaps = 860 px) não cabe e a 4ª pílula vazaria. Rótulo em cima e pílulas embaixo em TODA largura; 4 colunas FIXAS de 150 px a partir de
 * `md` (a 640 px o cartão tem 544 px < 624; a 768 tem 672 ≥ 624 — por isso `md` e não `sm`). Colunas fixas, nunca `1fr`: com `1fr` a
 * linha de 3 pílulas desalinha das de 4 (a cicatriz do D1).
 */
export const GRADE_DA_LINHA_EMPILHADA = "grid gap-3 border-b py-4 last:border-b-0";
export const GRADE_DAS_PILULAS_EMPILHADA =
  "grid max-w-[420px] grid-cols-2 gap-2 md:max-w-none md:grid-cols-[repeat(4,150px)]";

/** Tudo o que depende da disposição, numa tabela só (as classes Tailwind aparecem por inteiro: o JIT não monta nome de classe). */
export const GRADES: Record<
  DisposicaoDaLinha,
  { linha: string; pilulas: string; alturaDaPilula: string; celulaVazia: string }
> = {
  lado: {
    linha: GRADE_DA_LINHA,
    pilulas: GRADE_DAS_PILULAS,
    alturaDaPilula: "xl:min-h-[36px]",
    celulaVazia: "hidden xl:block",
  },
  empilhada: {
    linha: GRADE_DA_LINHA_EMPILHADA,
    pilulas: GRADE_DAS_PILULAS_EMPILHADA,
    alturaDaPilula: "md:min-h-[36px]",
    celulaVazia: "hidden md:block",
  },
};
